export interface Aircraft extends AircraftDocument {
  documentID: string;
}

export interface AircraftDocument {
  clientID?: string;
  registration: string;
  serialNumber: string; // e.g., 'S/N 6214'
  model: string;
  manufacturer: string;
  year: number;
  status: AIRCRAFT_STATUS;

  // New fields
  airframe: {
    totalTimeSinceNew: number; // e.g., 2693.2 hours
    landingsSinceNew: number; // e.g., 771
    airWorthnessDate: Date; // e.g., 'June 2016'
    maintenanceTracking: string; // e.g., 'CAMP'
    programCoverage: string; // e.g., 'Rolls-Royce CorporateCare'
  };

  engines: {
    // For overall engine info
    model: string; // e.g., 'BR725'
    manufacturer: string; // e.g., 'Rolls-Royce'
    programCoverage: string;

    // If you need per-engine details
    engineL: {
      serialNumber: string;
      hoursSinceNew: number;
      cyclesSinceNew: number;
    };
    engineR: {
      serialNumber: string;
      hoursSinceNew: number;
      cyclesSinceNew: number;
    };
  };

  avionics: string;

  apu: {
    manufacturer: string; // e.g., 'Honeywell'
    model: string; // e.g., 'RE220'
    serialNumber: string;
    timeSinceNew: number;
    programCoverage: string;
  };

  connectivityAndEntertainment: {
    internet: string; // e.g., 'SwiftBroadband'
    phone: string; // e.g., 'Aircell Axxess II'
    display: string; // e.g., 'Forward Cabin Display'
  };

  aircraftServiceChanges: { [key: string]: string }[];
  // e.g., ['ASC 123', 'ASC 456']

  interior: {
    noOfPassengers: number; // e.g., 8
    galleryLocation: string; // e.g., 'Forward Galley'
    forwardCabinConfiguration: string; // e.g., '4-place club'
    midCabinConfiguration: string; // e.g., '2-place divan'
    aftCabinConfiguration: string; // e.g., '2-place club'
    lavatory: string; // e.g., 'Forward Lavatory'
    crewRestArea: string; // e.g., 'No Crew Rest Area'
    jumpSeat: string; // e.g., 'No Jump Seat'
    lastRefurbishmentDate: Date; // e.g., 'January 2020'
  };
  // likewise, can be an object for seating config, materials, refurbishment date, etc.

  exterior: {
    basePaintColor: string; // e.g., 'White'
    stripeColor: string; // e.g., 'Blue'
    lastRefurbishmentDate: Date; // e.g., 'January 2020'
  };
  // or use an object if you want multiple fields (paint color, finish date, etc.)

  majorInspectionStatus?: {
    // You can break these out as needed
    month12?: string; // e.g., 'Completed December 2020'
    month24?: string; // e.g., 'Due December 2024'
    month48?: string; // e.g., 'Not yet applicable'
    month96?: string; // e.g., 'Not yet applicable'
  };
}

export enum AIRCRAFT_STATUS {
  ACTIVE = 'active',
  MAINTENANCE = 'maintenance',
  RETIRED = 'retired',
}
